import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";
import CallBackView from "../views/wxLogin.vue";

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/personal",
    name: "personal",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/personal/index.vue"),
  },
  {
    path: "/creator",
    name: "creator",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/creator/index.vue"),
  },
  {
    path: "/creatorMore",
    name: "creatorMore",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/more/creator.vue"),
  },
  {
    path: "/galleryMore",
    name: "galleryMore",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/more/gallery.vue"),
  },
  {
    path: "/hotMore",
    name: "hotMore",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/more/hot.vue"),
  },
  {
    path: "/creatorReg",
    name: "creatorReg",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/creator/reg.vue"),
  },
  {
    path: "/goodsDetail",
    name: "goodsDetail",
    component: () => import("../views/detail/goodsDetail.vue"),
  },
  {
    path: '/design',
    name: 'design',
    component: () => import('../views/detail/designNew.vue')
  },
  {
    path: "/jump",
    name: "jump",
    component: () => import("../views/wxLogin.vue"),
  },
  {
    path: "/payTest",
    name: "payTest",
    component: () => import("../views/payDemo/aliPayDemo.vue"),
  },
  {
    path: "/product",
    name: "product",
    component: () => import("../views/more/product.vue"),
  },
  {
    path: "/creator/product/reg",
    name: "creatorProductReg",
    component: () => import("../views/creator/product/reg.vue"),
  },
  {
    path: "/creator/product/img",
    name: "creatorProductImg",
    component: () => import("../views/creator/product/img.vue"),
  },
  {
    path: "/creator/product/product",
    name: "creatorProduct",
    component: () => import("../views/creator/product/product.vue"),
  },
  {
    path: "/personal/heart",
    name: "heart",
    component: () => import("../views/personal/heart.vue"),
  },
  {
    path: "/personal/address",
    name: "address",
    component: () => import("../views/personal/address.vue"),
  },
  {
    path: "/personal/upload",
    name: "upload",
    component: () => import("../views/personal/upload.vue"),
  },
  {
    path: "/map",
    name: "Map",
    component: () => import("../views/more/map.vue"),
  },
  {
    path: "/personal/points",
    name: "points",
    component: () => import("../views/personal/points.vue"),
  },
  {
    path: "/ai",
    name: "ai",
    component: () => import("../views/ai/index.vue"),
  },
  {
    path: "/lottery",
    name: "lottery",
    component: () => import("../views/lottery/index.vue"),
  },
  // ,{
  //   path: '/about',
  //   name: 'about',
  //   component: () => import(/* webpackChunkName: "about" */ '../views/wxLogin.vue')
  // }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
